import { Avatar, Paper, Tooltip } from '@mui/material';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import FlagIcon from '@mui/icons-material/Flag';
import PlaceIcon from '@mui/icons-material/Place';

export function StepMarker({ color, step, isStart, isEnd, size="large" }) {
  const largeMarker = size ==="large";
  const avatarSize = largeMarker ? 30 : 15;

  return (
    <Tooltip title={step.name}>
      <Paper elevation={3} sx={{ p: 0.3, bgcolor: largeMarker ? 'white' : color, borderRadius: '50%' }}>
        {(largeMarker|| isEnd) && (
          <Avatar sx={{ bgcolor: color, width: avatarSize, height: avatarSize }}>
            {isStart ? <OutlinedFlagIcon fontSize={'small'} /> 
            : isEnd ? (largeMarker ? <FlagIcon fontSize={'small'} /> : <PlaceIcon fontSize={'small'} />)
            : <PlaceIcon fontSize={'small'} />}
          </Avatar>
        )}
      </Paper>
    </Tooltip>
  );
}
